export function flushMobileLayout() {
    setTimeout(() => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--app-height', `${vh}px`);
        document.documentElement.style.setProperty('--layout-flush-trigger', `${Date.now()}px`);
    }, 100);
}
